var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "header-icon cursor-default",
      attrs: {
        href: "#",
        title: _vm.titlePanel,
        "data-toggle": "tooltip-city",
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.onClick.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 16 16",
            width: "24",
            height: "24",
          },
        },
        [
          _c("path", {
            attrs: {
              fill: "currentColor",
              d: "M13,13H3c-1.654,0-3-1.346-3-3c0-1.294,0.835-2.433,2.034-2.84c0.165-1.119,1.022-1.975,2.101-2.134 C4.576,3.275,6.169,2,8,2c1.463,0,2.791,0.792,3.493,2.049C13.39,3.696,15,5.18,15,7c0,0.231-0.029,0.465-0.086,0.696 C15.6,8.264,16,9.101,16,10C16,11.654,14.654,13,13,13z M4.525,5.502L4.449,5.997C3.673,6,3,6.673,3,7.5l0.012,0.422L2.603,8.04 C1.674,8.227,1,9.051,1,10c0,1.103,0.897,2,2,2h10c1.103,0,2-0.897,2-2c0-0.686-0.351-1.316-0.938-1.688l-0.346-0.219l0.146-0.383 C13.954,7.473,14,7.233,14,7c0-1.103-0.897-2-2-2c-0.191,0-0.394,0.036-0.62,0.11l-0.437,0.145l-0.18-0.424 C10.292,3.719,9.208,3,8,3C6.525,3,5.254,4.107,5.045,5.575l-0.062,0.43H4.55L4.525,5.502L4.525,5.502z",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }